import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { OrganizationInvitationsCard, OrganizationMembersCard } from "@papier/auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/members")({
  component: RouteComponent,
});

function RouteComponent() {
  const invalidateOrganization = useInvalidateOrganization();

  return (
    <div className="flex w-full flex-col gap-4 md:gap-6">
      <OrganizationMembersCard onLeaveOrganizationSuccess={invalidateOrganization} />
      <OrganizationInvitationsCard />
    </div>
  );
}
